export default "__VITE_ASSET__76a3658f__"